module.exports = __webpack_public_path__ + "static/media/fly0231.7fbde1b6.webp";